module.exports = __webpack_public_path__ + "a3e66a7ebbd0a6539298ba3c7aea4b67.svg";